export const SEARCH_CONTENT_SIZE = 10;
export const SEARCH_INPUT_MAX_LENGTH = 150;
export const SEARCH_GUIDES_INPUT_MAX_LENGTH = 127;

export const SEARCH_QUERY_LENGTH = 3;
export const SEARCH_DEBOUNCE_DELAY = 1000;
